// Librerías
import React, { useState, useEffect, Suspense } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
// Componentes
import SelectCity from "./SelectCity.js";
import SelectDate from "./SelectDate.js";
// Recursos
import "../../assets/styles/MainSearch/__maininputsearch.sass";
import search from "../../assets/static/Landing/icon/search.svg";
import * as serachActions from "../../store/search/actions"; // 🎯 FIX: Agregar "as"
import "../../../src/assets/styles/Buttons/btn.sass";
import { isMobile } from "react-device-detect";
import backgroundSearch from "../../assets/static/landing-host/background-search.webp";
import ImageLazyLoad from "../ui/image-lazyLoad/index.js";
import AdultsAndChild from "./AdultsAndChild.js";
import useCurrentLanguaje from "../../services/currentlenguaje.js";
import globalJson from "../../utilities/traduccGlobal.json";
import mainSearchJson from "./tradMainSearch.json";
import { useLanguage } from "../../store/lenguaje/useLenguaje.js";

const MainInputSearchNew = (props) => {
  const { addSearch } = props;
  const { login } = props.userReducer;
  const navbar = addSearch ? "navbar" : "";
  const [city, setCity] = useState(
    props.searchReducer.cityName ? props.searchReducer.cityName : false
  );
  const { handleFilterLang } = useCurrentLanguaje();
  const { currentLang } = useLanguage();
  const [adults, setAdults] = useState(1);
  const [childs, setChilds] = useState(0);
  const [checkin, setCheckin] = useState();
  const [checkout, setCheckout] = useState();
  const history = useHistory();
  const [urlInit, setUrlInit] = useState(false);
  const [errorSearch, setErrorSearch] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [cityName, setCityName] = useState(props.searchReducer.cityName);

  // 🎯 Estados para el sistema de foco
  const [activeSection, setActiveSection] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // 🎯 Función para manejar el foco de secciones
  const handleSectionFocus = (section) => {
    if (activeSection === section) {
      // Si ya está activo, lo desactivamos
      setActiveSection(null);
    } else {
      // Si es una sección diferente, activamos la transición
      if (activeSection && activeSection !== section) {
        setIsTransitioning(true);
        setTimeout(() => {
          setActiveSection(section);
          setIsTransitioning(false);
        }, 150); // Duración de la transición
      } else {
        setActiveSection(section);
      }
    }
  };

  // 🎯 Función para cerrar el foco (hacer clic fuera)
  const handleBlur = () => {
    setActiveSection(null);
  };

  // 🔧 ARREGLAR: Funciones mejoradas para manejar cambios de adultos y menores
  const handleAdultsChange = (newValue) => {
    setAdults(newValue);
    props.setAdult(newValue);
  };

  const handleChildsChange = (newValue) => {
    setChilds(newValue);
    props.setChild(newValue);
  };

  const query = queryString.parse(window.location.search);

  useEffect(() => {
    if (!urlInit) {
      if (query["city"]) {
        setCity(parseInt(query.city));
        props.setCity({ city: parseInt(query.city), cityName: query.cityName });
        props.setAdult(
          !isNaN(parseInt(query.adults)) ? parseInt(query.adults) : 1
        );
        props.setChild(
          !isNaN(parseInt(query.childs)) ? parseInt(query.childs) : 0
        );
        props.setCheckin(query.checkin ? query.checkin : "");
        props.setCheckout(query.checkout ? query.checkout : "");
        setUrlInit(true);
      }
    } else {
      setCity(props.searchReducer.city);
      setAdults(props.searchReducer.adults);
      setChilds(props.searchReducer.childs);
      setCheckin(props.searchReducer.checkin);
      setCheckout(props.searchReducer.checkout);
    }
  }, [props]);

  const goSearch = () => {
    const { city, checkin, checkout, childs, adults, neighborhood } = props.searchReducer;
    const cityNameSearch = cityName.replace(/\s+/g, "-");
    const hasNeighborhood = neighborhood && neighborhood !== "false";

    if (city && checkin && checkout && city && cityName) {
      const searchParams = new URLSearchParams({
        city,
        checkin,
        checkout,
        childs,
        adults,
        cityName,
      });

      if (hasNeighborhood) {
        searchParams.set("locationNeighborhood", neighborhood);
      }

      history.push(`/${cityNameSearch}/search?${searchParams.toString()}`);
      props.setTriggerSearch();
    }

    if (city && cityName && (checkin === "" || checkout === "")) {
      const searchParams = new URLSearchParams({
        city,
        childs,
        adults,
        cityName,
      });

      if (hasNeighborhood) {
        searchParams.set("locationNeighborhood", neighborhood);
      }

      history.push(`/${cityNameSearch}/search?${searchParams.toString()}`);
      props.setTriggerSearch();
    }
  };

  const handleSearch = (e) => {
    goSearch();
  };
  
  const getMissingFieldLabel = () => {
    const selectedCityName = props.searchReducer.cityName || cityName;
    if (!props.searchReducer.city || !selectedCityName) {
      return "Donde vamos";
    }
    if (!props.searchReducer.checkin) {
      return "Fecha inicio";
    }
    if (!props.searchReducer.checkout) {
      return "Fecha fin";
    }
    return "";
  };

  const preSearch = () => {
    const missingField = getMissingFieldLabel();
    if (missingField) {
      setErrorSearch(true);
      setErrorMessage(`Completar Dato ${missingField}`);
      return;
    }
    setErrorSearch(false);
    setErrorMessage("");
    handleSearch();
  };

  useEffect(() => {
    if (
      props.searchReducer.checkin &&
      props.searchReducer.checkout &&
      props.searchReducer.cityName
    ) {
      setCheckin(props.searchReducer.checkin);
      setCheckout(props.searchReducer.checkout);
      setCityName(props.searchReducer.cityName);
    } else {
      setCheckin("");
      setCheckout("");
      setCityName("");
    }
  }, [
    props.searchReducer.checkin,
    props.searchReducer.checkout,
    props.searchReducer.cityName,
  ]);

  useEffect(() => {
    if (checkout) {
      setErrorSearch(false);
    }
  }, [checkout]);

  useEffect(() => {
    if (!getMissingFieldLabel()) {
      setErrorSearch(false);
      setErrorMessage("");
    }
  }, [props.searchReducer.city, props.searchReducer.cityName, props.searchReducer.checkin, props.searchReducer.checkout, cityName]);

  // 🎯 Función para obtener las clases CSS según el estado
  const getSectionClasses = (section, baseClasses, extraClasses = '') => {
    const classes = [baseClasses, extraClasses];
    
    classes.push('search-section');
    
    if (activeSection === null) {
      classes.push('search-section--normal');
    } else if (activeSection === section) {
      classes.push('search-section--active');
    } else {
      classes.push('search-section--inactive');
    }

    if (isTransitioning) {
      classes.push('search-section--transitioning');
    }

    return classes.filter(Boolean).join(' ');
  };

  return (
    <Suspense fallback={<></>}>
      <div
        className={`search-container ${activeSection ? 'search-container--focused' : ''} relative ${
          addSearch && "sm:p-[0!important] max-w-[800px!important]"
        } pt-8vw MainInputSearch ${navbar}  sm:min-w-[600px]  h-full mx-auto w-11/12 sm:w-[69.2vw] min-w-0 sm:max-w-full sm:max-h-96 sm:h-[8.2vw] sm:rounded-150 sm:pl-[4%] sm:flex sm:justify-between sm:items-center p-0 flex flex-col sm:flex-row`}
      >
        {/* 🎯 IMAGEN DE FONDO MOBILE - MOVIDA AL TOP */}
        {isMobile && (
          <div className="background-image">
            <ImageLazyLoad
              src={backgroundSearch}
              alt="Background"
              classNameContent={"w-full h-full"}
              className="w-full h-full bg-no-repeat bg-cover bg-backgroundSearch"
            />
          </div>
        )}

        {/* 🎯 SECCIÓN 1: CIUDAD - SIMPLIFICADA PARA MOBILE */}
        <div
          className={getSectionClasses('city', `${
            addSearch && "sm:w-auto navSearch"
          } sm:w-[25%] border-b-2 sm:flex sm:flex-col sm:justify-center border-black MainInputSearch__cities p-[0] sm:border-none  sm:max-h-full sm:h-full m-0`)}
          onClick={() => !isMobile && handleSectionFocus('city')}
        >
          <div
            className={`flex flex-col items-center sm:justify-between p-0 sm:ml-[15%]  MainInputSearch__container sm:items-start sm:h-[65%] ${
              addSearch && "navSearch"
            }`}
          >
            {isMobile ? (
              // 🎯 MOBILE: Solo mostrar nombre de ciudad seleccionada
              <h2 onClick={() => props.setCity(false)}>
                <strong>{props.searchReducer.cityName || "Selecciona un destino"}</strong>
              </h2>
            ) : (
              // 🎯 DESKTOP: Combo completo
              <>
                <label
                  onClick={() => props.setCity(false)}
                  className={`hidden p-0 font-extrabold MainInputSearch__container__label sm:grid ${
                    addSearch && "sm:text-[.8rem]"
                  }`}
                >
                  {handleFilterLang(mainSearchJson).cualEsTuProximoDestino}
                </label>
                <SelectCity
                  cityName={props.searchReducer.cityName}
                  newStyle={true}
                  selectedCity={city}
                  placeholder={
                    props.searchReducer.cityName
                      ? props.searchReducer.cityName
                      : handleFilterLang(mainSearchJson).dondeVamos
                  }
                />
              </>
            )}
          </div>
        </div>

        {/* 🎯 WRAPPER PARA ADULTOS Y MENORES */}
        {isMobile ? (
          <div className="mobile-people-wrapper">
            <div className={getSectionClasses('adults', `MainInputSearch__people search-section--adults`)}>
              <div className="MainInputSearch__container">
                <label className="MainInputSearch__container__label">
                  {handleFilterLang(globalJson).adultos}
                </label>
                <AdultsAndChild
                  title=""
                  setValue={handleAdultsChange}
                  value={adults}
                  addSearch={addSearch}
                />
              </div>
            </div>

            <div className={getSectionClasses('children', `MainInputSearch__people search-section--children`)}>
              <div className="MainInputSearch__container">
                <label className="MainInputSearch__container__label">
                  {handleFilterLang(globalJson).menores}
                </label>
                <AdultsAndChild
                  title=""
                  setValue={handleChildsChange}
                  value={childs}
                  addSearch={addSearch}
                />
              </div>
            </div>
          </div>
        ) : (
          // 🎯 DESKTOP - COMPONENTES SEPARADOS (sin cambios)
          <>
            <div
              className={getSectionClasses('adults', `${
                addSearch && "sm:w-auto"
              } MainInputSearch__people sm:w-max p-0 ml-2 sm:max-h-full h-[23vw] sm:h-full sm:items-center`, 'search-section--adults')}
              onClick={() => handleSectionFocus('adults')}
            >
              <div className="sm:h-[65%] sm:flex flex-row MainInputSearch__container items-center justify-center">
                <AdultsAndChild
                  title={handleFilterLang(globalJson).adultos}
                  setValue={handleAdultsChange}
                  value={adults}
                  addSearch={addSearch}
                />
              </div>
            </div>

            <div
              className={getSectionClasses('children', `${
                addSearch && "sm:w-auto"
              } MainInputSearch__people sm:w-max p-0 ml-2 sm:max-h-full h-[23vw] sm:h-full sm:items-center`, 'search-section--children')}
              onClick={() => handleSectionFocus('children')}
            >
              <div className="sm:h-[65%] sm:flex flex-row MainInputSearch__container items-center justify-center">
                <AdultsAndChild
                  title={handleFilterLang(globalJson).menores}
                  setValue={handleChildsChange}
                  value={childs}
                  addSearch={addSearch}
                />
              </div>
            </div>
          </>
        )}

        {/* 🎯 SECCIÓN 4: FECHAS */}
        <div 
          className={getSectionClasses('dates', "MainInputSearch__dates sm:h-[100%] p-0   max-sm:max-w-[100%] sm:max-w-[270px] sm:max-w-auto sm:w-max sm:max-h-full  items-center")}
          onClick={() => !isMobile && handleSectionFocus('dates')}
        >
          <div
            className={`w-full MainInputSearch__container  sm:w-72 sm:h-[65%] justify-between ${
              addSearch && "navSearch"
            }`}
          >
            {!isMobile && (
              <label
                className={`${
                  addSearch && "text-[.8rem]"
                } hidden p-0 mx-auto font-extrabold text-center sm:grid MainInputSearch__container__label`}
              >
                {handleFilterLang(mainSearchJson).cuando}
              </label>
            )}
            {errorSearch && (
              <span className="MainInputSearch__container__alert">
                {errorMessage}
              </span>
            )}
            <span className={`flex justify-center w-full mx-auto ${
              isMobile 
                ? "h-full border border-gray-300 rounded-lg" 
                : "h-[23vw] border-t-2 border-b-2 sm:h-[60%] border-t-black border-b-black sm:border-none mt-[2px] sm:mt-0"
            }`}>
              <SelectDate
                lenguaje={currentLang}
                from={handleFilterLang(globalJson).desde}
                to={handleFilterLang(globalJson).hasta}
                format={isMobile && "DD | MM | YY "}
                newStyle={true}
                checkin={props.searchReducer.checkin}
                checkout={props.searchReducer.checkout}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
              />
            </span>
          </div>
        </div>

        {/* 🎯 BOTÓN DE BÚSQUEDA MÓVIL - NUEVO DISEÑO */}
        {isMobile && (
          <button
            aria-label="search"
            className="MobileMainInputSearch"
            onClick={() => preSearch()}
          >
            <img src={search} alt="Buscar" />
            <p>Buscar</p>
          </button>
        )}

        {/* BOTÓN DE BÚSQUEDA DESKTOP */}
        {!isMobile && (
          <div className="items-center justify-center hidden max-w-xl sm:flex max-h-24 MainInputSearch__btncontainer">
            <button
              aria-label="pre search"
              className="w-[6.2vw] h-[6.2vw] -translate-x-4 MainInputSearch__searchButton"
              onClick={() => preSearch()}
            >
              <img
                src={search}
                alt="Buscar"
                className="MainInputSearch__searchButton__img"
              />
            </button>
          </div>
        )}
      </div>
    </Suspense>
  );
};

const mapStateToProps = (reducers) => {
  return {
    searchReducer: reducers.searchReducer,
    userReducer: reducers.userReducer,
  };
};

export default connect(mapStateToProps, serachActions)(MainInputSearchNew);
